import React, {
    Component
} from 'react';
import './TutorialPage.css';

import PageBuilder from '../../interfaces/PageBuilder.js';

import TutorialSideBar from '../../components/TutorialSideBar/TutorialSideBar.js';
import SideBar from '../../components/SideBar/SideBar';



class TutorialPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 'search'
        }
    }  

    componentDidUpdate(prevState){
        if(prevState.currentPage != this.state.currentPage){
            document.getElementById("content").scrollTo(0,0);
        }
    }

    render() {
        let contents = ''
        
        // set currentPage to currently selected sidebar entry
        let sidebarEntries = [
            {
                title: 'Searching',
                path: 'search',
                callback: () => { this.setState({ currentPage: 'search' }) }
            },
            {
                title: 'Analyzing Results',
                path: 'results',
                callback: () => { this.setState({ currentPage: 'results' }) }
            },
            {
                title: 'Generating a Report',
                path: 'report',
                callback: () => { this.setState({ currentPage: 'report' }) }
            },
            {
                title: 'Bulk Image Upload',
                path: 'upload',
                callback: () => { this.setState({ currentPage: 'upload' }) }
            }
        ];
        // Include html files located within TutorialPage/HTMLAssets in the current scope
        const htmlFiles = {
            'report': require('./HTMLAssets/report.html'),
            'results': require('./HTMLAssets/results.html'),
            'upload': require('./HTMLAssets/upload.html'),
            'search': require('./HTMLAssets/search.html')
        };
        // set current HTML content to be the file associated with the selected sidebar entry
        contents = htmlFiles[this.state.currentPage];
        

        // dangerouslySetInnerHTML loads the raw HTML file into the returned element below
        return (
            <div className="contents">
                <TutorialSideBar selectedEntry={this.state.currentPage} entries={sidebarEntries} />
                <div className="tutorialsection" id= "content">
                    <div className="tutorialcontent">
                        <div dangerouslySetInnerHTML={{__html: contents}} />
                    </div>
                </div>
                
            </div>
             
        );
    }

}
class TutorialPageBuilder extends PageBuilder {

    // @override
    async onPageLoad() {
        return;
    }

    // @override
    pageContent() {
        return (
            <TutorialPage />
        );
    }

}

export {
    TutorialPage,
    TutorialPageBuilder
};
